import moment from 'moment';
import { luftPost } from '../shared/http';

// actions

const SEND_SUGGESTION = 'luft/suggestion/SEND_SUGGESTION';
const SEND_SUGGESTION_SUCCESS = 'luft/suggestion/SEND_SUGGESTION_SUCCESS';
const SEND_SUGGESTION_FAILURE = 'luft/suggestion/SEND_SUGGESTION_FAILURE';
const SEND_SUGGESTION_CLEAR = 'luft/suggestion/SEND_SUGGESTION_CLEAR';

// reducer

const initialState = {
  sendSuggestion: {
    isFetching: false,
    requested: '',
    error: '',
  },
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case SEND_SUGGESTION:
      return {
        ...state,
        sendSuggestion: {
          ...state.sendSuggestion,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case SEND_SUGGESTION_SUCCESS:
      return {
        ...state,
        sendSuggestion: {
          ...state.sendSuggestion,
          isFetching: false,
          error: '',
        },
      };

    case SEND_SUGGESTION_FAILURE:
      return {
        ...state,
        sendSuggestion: {
          ...state.sendSuggestion,
          error: action.error,
          isFetching: false,
        },
      };

    case SEND_SUGGESTION_CLEAR:
      return {
        ...state,
        sendSuggestion: {
          ...state.sendSuggestion,
          requested: '',
          isFetching: false,
          error: '',
        },
      };

    default:
      return state;
  }
}

export default reducer;

// action creators

function _sendSuggestion() {
  return { type: SEND_SUGGESTION };
}

function _sendSuggestionSuccess() {
  return { type: SEND_SUGGESTION_SUCCESS };
}

function _sendSuggestionFailure(error) {
  return {
    type: SEND_SUGGESTION_FAILURE,
    error,
  };
}

export function sendSuggestionClear() {
  return { type: SEND_SUGGESTION_CLEAR };
}

// thunk action creators

export function sendSuggestion(text) {
  return function (dispatch) {
    return (async () => {
      try {
        dispatch(_sendSuggestion());
        const requestBody = { text };
        await luftPost('/Suggestion', requestBody);
        dispatch(_sendSuggestionSuccess());
        return true;
      } catch (error) {
        console.log(error);
        dispatch(_sendSuggestionFailure(error.message));
        throw new Error(error.message);
      }
    })();
  };
}
